import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { AuthServicesService } from 'src/app/services/auth-services.service';
import { FirebaseFunctionsService } from '../../services/firebase-functions.service';

@Component({
  selector: 'app-se-connecter',
  templateUrl: './se-connecter.component.html',
  styleUrls: ['./se-connecter.component.scss']
})
export class SeConnecterComponent implements OnInit {

  courriel = '';
  mdp = '';
  passwordState = 'password';
  constructor(private auth: AuthServicesService, public app:AppComponent, private afs: FirebaseFunctionsService) {
   }

  ngOnInit(): void {
    setTimeout(this.app.afficherPage,2000);
  }
  emailValidation(){
    const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-\.]+\.[a-zA-Z0-9-]{2,}$/;
    if(this.courriel.match(mailformat)){return true;}else{return false;}
  }
  passwordValidation(){
    const pwdformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{6,}$/;
    if(this.mdp.match(pwdformat)){return true;}else{return false;}
  }
  managePasswordState(){
    this.passwordState = (this.passwordState == 'password') ? 'text': 'password';
  }
  go(url: string){
    this.app.navigateTo(url);
  }
  seConnecter(){
    const emailValidate = this.emailValidation();
    const pwdValidate = this.passwordValidation();
    if(emailValidate == true && pwdValidate == true){
      this.auth.loginUser(this.courriel, this.mdp).then( (user) => {
        this.go('/accueil');;
      }).catch( err => {
        if(err.code == 'auth/wrong-password' || err.code == 'auth/user-not-found'){
          this.app.showMessage(3, 'Le courriel ou le mot de passe est incorrecte.', 3000);
        }
        if(err.code == 'auth/network-request-failed'){
          this.app.showMessage(3,'Nous éprouvons des difficultés à nous connecter sur le wifi. Veuiller vérifier votre connexion internet.', 3000);
        }
      })
    }else{
      if(emailValidate == false){
        this.app.showMessage(3,'Le courriel n\'est pas valide', 3000);
      }else{
        this.app.showMessage(3, 'Le mot de passe doit contenir au moins 6 characteres alphanumerique', 5000);
      }
    }
  }
}
